import authActions from './auth'
import coreActions from './core'
import projectActions from './project'
import systemActions from './system'
import workspaceActions from './workspace'
import onboardingActions from './onboarding'

export default {
  ...authActions,
  ...coreActions,
  ...projectActions,
  ...systemActions,
  ...workspaceActions,
  ...onboardingActions
}